import { STEP } from "#src/constants/step.ts";
import { defineStore } from "#src/stores/state-wrapper.ts";

import { useStepBirthdateStore } from "#src/stores/step-birthdate.ts";
import { useStepQuoteStore } from "#src/stores/step-quote.ts";
import { useInstanceSettingsStore } from "#src/stores/instance-settings.ts";
import { type Pinia, type StoreGeneric } from "pinia";
import { type BaseStepStore } from "#src/types/StepStore.ts";
import { computed, type ComputedRef } from "vue";

interface CompareState {
  inactive: ComputedRef<boolean>;
  nextText: ComputedRef<string>;
}

interface CompareStep extends BaseStepStore, CompareState {}

function initializeCompareStep(pinia: Pinia): CompareStep {
  const step = computed(() => STEP.COMPARE);
  const nextText = computed(() => "Next - View Carriers");
  const previous = computed(() => {
    const birthdate = useStepBirthdateStore(pinia);
    if (birthdate.next === step.value) {
      if (birthdate.inactive) return birthdate.previous;
      return birthdate.step;
    }
    return STEP.LIFE_INSURANCE_PRIORITY;
  });
  const controlsNext = computed(() => true);
  const next = computed(() => {
    const quote = useStepQuoteStore(pinia);
    return quote.step;
  });
  const inactive = computed(() => {
    const instanceSettingsStore = useInstanceSettingsStore(pinia);
    return (
      instanceSettingsStore.onlyAccidentalDeath ||
      instanceSettingsStore.onlyOnePermanentProduct
    );
  });

  function $reset() {}

  return {
    $reset,
    step,
    nextText,
    previous,
    controlsNext,
    next,
    inactive,
  };
}

export const useStepCompareStore = (pinia: Pinia, hot?: StoreGeneric) => {
  return defineStore<string, CompareStep>("step-compare", () => {
    return initializeCompareStep(pinia);
  })(pinia, hot);
};
